// extracted by mini-css-extract-plugin
export default {"text_num":"TextNum_text_num__kjTZW","title":"TextNum_title__fTbEj","num":"TextNum_num__2fB8W"};